import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "containers.FolderRecommendations.widgetTitle",
    defaultMessage: `
      More inspiring content for your <a href={url}><span class="widgets-folder">{folder}</span></a> folder
    `
  }
});

export default messages;
